const LoadingCard: React.FC<{
  /** @default 1 */
  amount?: number;
}> = props => Array.from({
  length: props.amount ?? 1
}, (_, i) => <div key={i} className="relative flex justify-between rounded-lg bg-white px-5 py-4 align-middle hover:cursor-pointer">
            <div className="relative flex w-full items-center gap-4 space-x-3">
                <div className="h-10 w-10 shrink-0 rounded-3xl bg-gray-50">
                    <div className="h-10 w-10 rounded-full bg-slate-200" />
                </div>
                <div className="w-full flex-1 gap-4">
                    <span className="absolute inset-0" aria-hidden="true" />
                    <div className="h-2 rounded-xs bg-slate-200" />
                    <p className="mt-4 truncate text-sm text-gray-500">
                        <span className="h-2 rounded-xs bg-slate-200" />
                    </p>
                </div>
            </div>
        </div>);
export default LoadingCard;